<template>
  <div class="vx-row pl-10 pr-10 sm:pl-0 justify-center sm:pr-0">
    <div class="vx-col p-2 copyright lg:w-3/5 xl:w-3/5" :class="copyrightClass">
      <div class="vx-row">
        <div class="vx-col w-100 lg:w-1/2 text-center lg:text-left">
          <img
            src="https://www.fsm.edu.tr/favicon.png?v=1.0"
            width="16"
            alt="FSM"
            style="vertical-align: middle; margin-left:5px;margin-right: 5px"
          />
          {{ $t("CopyrightLeft") }}
        </div>
        <div class="vx-col w-100 lg:w-1/2 text-center lg:text-right pl-0 pr-0">
          <span class="block lg:inline">{{ $t("CopyrightRight") }}</span>
          <template>
            <!-- I18N -->
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="cursor-pointer lg:float-right mt-1 lg:ml-3 lg:mr-5"
            >
              <span class="cursor-pointer flex i18n-locale">
                <img
                  class="h-4 w-5"
                  :src="require(`@/assets/images/flags/${$i18n.locale}.png`)"
                  :alt="$i18n.locale"
                />
                <span class="sm:block ml-2 mr-2">{{
                  getCurrentLocaleData.lang
                }}</span>
              </span>
              <vs-dropdown-menu class="w-40 i18n-dropdown vx-navbar-dropdown">
                <vs-dropdown-item @click="updateLocale('tr')">
                  <img
                    class="h-4 w-5 mr-1"
                    src="@/assets/images/flags/tr.png"
                    alt="tr"
                  />
                  &nbsp;Türkçe
                </vs-dropdown-item>
                <vs-dropdown-item @click="updateLocale('en')">
                  <img
                    class="h-4 w-5 mr-1"
                    src="@/assets/images/flags/en.png"
                    alt="tr"
                  />
                  &nbsp;English
                </vs-dropdown-item>
                <vs-dropdown-item @click="updateLocale('ar')">
                  <img
                    class="h-4 w-5 mr-1"
                    src="@/assets/images/flags/ar.png"
                    alt="tr"
                  />
                  &nbsp;عربي
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyrightClass: "",
    };
  },
  computed: {
    breakpoint() {
      return this.$store.state.breakpoint;
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
      else if (locale == "ar") return { flag: "ar", lang: "عربي" };
    },
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (locale == "ar") this.$vs.rtl = true;
      else this.$vs.rtl = false;
    },
  },
  created() {
    setTimeout(() => {
      this.copyrightClass = "show";
    }, 1000);
  },
};
</script>

<style>
.copyright {
  background: white;
  font-weight: 500;
  position: relative;
  -webkit-border-top-left-radius: 20px;
  -webkit-border-top-right-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-topright: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  -webkit-transition: all 1s ease-out;
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  transition: all 1s ease-out;
  color: #000;
}
</style>
